<script lang="ts">
	import Input from '$lib/components/Global/Fields/Input.svelte';
	import { type ComponentProps } from 'svelte';
	import { type StepUpdater } from '../../Stepper/stepper';
	import FieldWrapper from './FieldWrapper.svelte';

	export let name: string;
	export let focusOnMount: boolean = false;
	export let onUpdate: StepUpdater<string> | null = null;

	interface $$Props extends ComponentProps<Input> {
		name: string;
		focusOnMount?: boolean;
		onUpdate?: StepUpdater<string> | null;
	}

	let value: string = '';

	function formatNumber(n: string) {
		return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}

	export function formatStrFloat(value: string): string {
		const floatChar = value.indexOf(',') >= 0 ? ',' : value.indexOf('.') >= 0 ? '.' : null;

		if (floatChar === null) {
			return formatNumber(value);
		}

		let decimalPos = value.indexOf(floatChar);
		let leftSide = value.substring(0, decimalPos);
		let rightSide = value.substring(decimalPos);

		leftSide = formatNumber(leftSide);
		rightSide = formatNumber(rightSide);
		rightSide = rightSide.substring(0, 2);

		return `${leftSide},${rightSide}`;
	}

	const customOnUpdate: StepUpdater<string> = (val, step) => {
		if (!onUpdate) {
			return { [name]: formatStrFloat(val) };
		}

		return onUpdate(val, step);
	};

	function handleInput(e: Event, handleUpdate: (e: Event) => void) {
		handleUpdate(e);
	}
</script>

<FieldWrapper
	{name}
	onUpdate={customOnUpdate}
	let:handleUpdate
	let:error
	on:value={(e) => {
		value = e.detail || '';
	}}
>
	<Input
		{name}
		{value}
		{error}
		{focusOnMount}
		{...$$restProps}
		on:input={(e) => handleInput(e, handleUpdate)}
		inputmode="numeric"
	>
		<div class="-ml-1 cursor-text rounded-sm bg-secondary text-white" slot="after">
			<p class="m-0 select-none px-[2px] py-[3px] leading-none">€</p>
		</div>
	</Input>
</FieldWrapper>
